// @flow

import React, { Component } from "react";
import { localize } from "redux-i18n";
import { connect } from "react-redux";
import { compose } from "redux";
import { Field, reduxForm } from "redux-form";
import type { FormProps } from "redux-form";
import { Dropdown } from "@components/form";
import {
  Form,
  FormGroup,
  Label,
  type StepProps,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Col,
} from "@components";
import type { State } from "@store/reducers";
import * as serviceSelectors from "@modules/service/selectors";
import type {
  ShiftPattern,
  UnassignReassignShiftPatternCauseType,
} from "@modules/service/reducer/shift-patterns/types";
import { UnassignReassignShiftPatternCauseEnum } from "@modules/service/constants";

export type FilterOption = $Exact<{ value: string, label: string }>;

type PropsFromState = $Exact<{
  newShiftPatternId: number,
}>;

type OwnProps = $Exact<{
  modalTitle: string,
  modalDescription: string,
  toggleModal: (visible: boolean) => void,
  cause: UnassignReassignShiftPatternCauseType,
  selectedShiftPatternId: number,
  shiftPatternsList: ShiftPattern[],
}>;

type Props = $Exact<{
  ...PropsFromState,
  ...StepProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
  ...OwnProps,
}>;

export class ReassignItemsToShiftPatternModal extends Component<Props> {
  componentDidMount() {
    const firstShiftPattern = this.shiftPatterns[0];
    this.props.initialize &&
      this.props.initialize({
        newShiftPatternId: (firstShiftPattern || {}).id,
      });
  }

  get dropdownOptions() {
    return this.shiftPatterns.map(shiftPattern => ({
      label: shiftPattern.name,
      value: shiftPattern.id,
    }));
  }

  get shiftPatterns() {
    return this.props.shiftPatternsList.filter(
      shiftPattern => shiftPattern.id !== this.props.selectedShiftPatternId,
    );
  }

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader toggle={this.props.toggleModal} className="d-flex justify-content-between">
          {this.props.modalTitle}
        </ModalHeader>
        <ModalBody className="d-flex justify-content-center align-items-center flex-column">
          {this.props.modalDescription}
          {this.props.cause === UnassignReassignShiftPatternCauseEnum.REASSIGN ? (
            <Col sm={{ size: 8 }}>
              <Form className="w-100 mb-5 mt-3">
                <FormGroup>
                  <Label for="shiftPattern">
                    {this.props.t("SELECT_SHIFT_PATTERN")}
                    <span className={"text-warning"}>*</span>
                  </Label>
                  <Field
                    id="shiftPattern"
                    name="newShiftPatternId"
                    component={Dropdown}
                    options={this.dropdownOptions}
                  />
                </FormGroup>
              </Form>
            </Col>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.toggleModal}>
            {this.props.t("CANCEL")}
          </Button>
          <Button
            onClick={this.props.actionHandler(
              this.props.cause === UnassignReassignShiftPatternCauseEnum.REASSIGN
                ? this.props.newShiftPatternId
                : null,
            )}
          >
            {this.props.t(this.props.cause)}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  newShiftPatternId: serviceSelectors.shiftPatternIdToReassign(state),
});

export default compose(
  reduxForm({
    form: "reassign-items-to-shift-pattern",
  }),
  localize(),
  connect(mapStateToProps, null),
)(ReassignItemsToShiftPatternModal);
